import React, {useContext, useState} from 'react';
import './Name.less';
import {Button} from "elements/button/Button";
import {Input} from "elements/input/Input";
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import {Error} from "elements/error/Error";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

export const NAME_POPUP = 'NAME_POPUP';

export const Name = ({defaultValue = '', error, onCancelClick, onDoneClick, onOverlayClick}) => {
	const [name, setName] = useState(defaultValue);

	const translations = useContext(TranslationsContext);

	return <DrawerPopup
		title={getSafeTranslation('NamePopup.title', translations)}
		onOverlayClick={onOverlayClick}
		leftControl={<Button isText onClick={onCancelClick}>{
			getSafeTranslation('NamePopup.cancelButtonCaption', translations)
		}</Button>}
		rightControl={<Button isAutoWidth onClick={() => onDoneClick(name)}>{
			getSafeTranslation('NamePopup.doneButtonCaption', translations)
		}</Button>}
	>
		<div className="name">
			<div className="name__input">
				<Input value={name} onChange={setName} focusOnMount/>
			</div>
			{
				error && (<div className="name__error">
					<Error text={error}/>
				</div>)
			}
		</div>
	</DrawerPopup>
}
